module.exports = __webpack_public_path__ + "img/In Game target_v2-125.d0aed3a7.png";